import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import CompetitorSection from './components/CompetitorSection';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';
import ArticleGrid from './components/ArticleGrid';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hoobuy.baby';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <title>HoobuySpreadsheet 2026 | Guia de Compras da China</title>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <CompetitorSection />
        <TestimonialSection />
        <CtaSection />
        <ArticleGrid />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'HoobuySpreadsheet 2026 | Guia de Compras da China',
            description: 'Descubra o HoobuySpreadsheet mais atualizado de 2026 com listas organizadas de produtos da China. Links verificados, guias de compra, comparações de preços e economia de até 70%.',
            url: SITE_URL + '/',
            mainEntity: {
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: 'O que é o HoobuySpreadsheet?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'O HoobuySpreadsheet é uma planilha organizada com listas de produtos da China, incluindo roupas, sneakers, acessórios e eletrônicos, com links diretos para compra e atualizações frequentes.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'O HoobuySpreadsheet é seguro?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Sim, o HoobuySpreadsheet utiliza links verificados e produtos testados pela comunidade, garantindo uma experiência de compra confiável e segura.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Como economizar usando o HoobuySpreadsheet?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'A planilha organiza produtos por categoria com comparações de preços reais, permitindo economia de até 70% em relação a marketplaces tradicionais.',
                  },
                },
              ],
            },
          }),
        }}
      />
    </div>
  );
}